var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-self-end"},[_c('a',{attrs:{"href":"https://programmerfair2020.vbooth.me/booth/Vdk3OPdX","target":"_blank"}},[_c('img',{attrs:{"src":require('@/images/game/buttons/button-camera.svg')}})])])}
var staticRenderFns = []

export { render, staticRenderFns }